import AdminConfig from './admin.vue';

import ClientView from './client.vue';


export default {
  name : 'geoloc',

  type : 'module',
  
  label: 'Géolocalisation',

  components: {

    admin: AdminConfig,

    client: ClientView

  },

  settings: {
    icon: 'mdi-map-marker-check-outline',
  }
}